export default "__VITE_ASSET__5f4ceaf0__"